import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './styles/index.css';
import './styles/print.css';
import App from './App';
import { queryClient } from './utils/queryClient';

// Unregister any service worker left over from a previous deployment.
// Older builds shipped a SW that intercepted /api/* requests with a stale
// backend URL, which now causes CORS failures. Force-removing it lets fresh
// builds talk to the correct backend without users having to clear caches.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((reg) => reg.unregister()))
    .catch(() => undefined);
  if (typeof caches !== 'undefined') {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .catch(() => undefined);
  }
}

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
